export const UPDATE_OPEN_PROCESS_STATEMENT_FAILURE = 'UPDATE_OPEN_PROCESS_STATEMENT_FAILURE';

export const updateOpenProcessStatementFailure = error => ({
    type: UPDATE_OPEN_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
